export const colors = {
    blue: "#88ADDB",
    orange: "#E36B2D",
    darkBlue: "#002B4A",
    green: "#E9F3FB",
    red: "#FDD7C6",
};
